import FormComponent from "./form.component.vue";
import Confirmation from "./confirmation.component.vue";

export default {
   components: {
      FormComponent,
      Confirmation,
   },
   data() {
      return {
         data: {
            current_page: 1,
            per_page: 10,
            total: 10,
            data: []
         },
         searchQuery: '',
         searchTimeout: null,
      };
   },
   async mounted() {
      await this.list({ page: 1, per_page: this.data.per_page });
   },
   methods: {
      async login(email) {
         let login = await this.$lionheart.post("v2/auth/login/email", { email: email }).then((response) => response.data);

         if (login.success) {
            await this.$storage.set("auth", login.data);
            location.href = "/dashboard/home";
         }
      },

      // Updated remove method to use new confirmation modal
      async remove(facilityId) {
         this.$refs.confirmationModal.showConfirmation(facilityId);
      },

      // New method to handle actual deletion
      async handleConfirmDelete(facilityId) {
         try {
            await this.$lionheart.delete("v2/dashboard/facilities/" + facilityId);
            // Don't refresh list here - wait for success step completion
         } catch (error) {
            console.error('Deletion failed:', error);
            // Handle error (maybe show error message)
         }
      },

      // New method to handle deletion completion
      async handleDeleteComplete() {
         // Refresh the list after successful deletion
         await this.list({ 
            page: this.data.current_page, 
            per_page: this.data.per_page,
            search: this.searchQuery 
         });
      },

      // Handle deletion cancellation (optional)
      handleCancelDelete() {
         // Can add any cleanup logic here if needed
         console.log('Deletion cancelled');
      },

      async paginate(page) {
         var filter = {
            page: page,
            per_page: this.data.per_page,
            search: this.searchQuery 
         };
         await this.list(filter);
      },

      handleSearch() {
         // Clear existing timeout
         if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
         }

         // Set new timeout for debouncing (wait 500ms after user stops typing)
         this.searchTimeout = setTimeout(() => {
            this.performSearch();
         }, 500);
      },

      async performSearch() {
         // Reset to first page when searching
         await this.list({
            page: 1,
            per_page: this.data.per_page,
            search: this.searchQuery
         });
      },

      // Clear search
      clearSearch() {
         this.searchQuery = '';
         this.performSearch();
      },

      async list(data) {
         var response = await this.$lionheart.get("dashboard/facilities", { params: data });
         this.data = response.data;

         console.log(this.data);
      },
   },
};